import * as LogRocket from "logrocket";

LogRocket.init('uiqtcg/fiscalpop-amazon');
console.log('==LOG R INIT ==')